/**
 * @packageDocumentation
 * @module ReloadControl
 * @category Core
 */
import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * Токен для провайдера контроля перезагрузки.
 *
 * @example
 * Пример реализации сервиса, запрашивающего перезагрузку данных каждую секунду:
 *
 * ```ts
 * class ExampleReloadControl implements ReloadControlProvider {
 *   shouldReloadData(): Observable<boolean> {
 *     return timer(1000).pipe(map(() => true));
 *   }
 * }
 *
 * providers: [
 *   {
 *     provide: RELOAD_CONTROL_PROVIDER,
 *     useClass: ExampleReloadControl,
 *     multi: true
 *   }
 * ]
 * ```
 *
 * @group Tokens
 *
 * @see {@link ReloadControlService}
 */
export const RELOAD_CONTROL_PROVIDER = new InjectionToken('Reload control provider');

/**
 * Интерфейс для провайдера контроля перезагрузки.
 *
 * @see {@link RELOAD_CONTROL_PROVIDER}
 *
 * @group Interfaces
 */
export interface ReloadControlProvider {
  shouldReloadData(): Observable<boolean>;
}
